import { AdDataAggregates, AdDataSearchRequest, AdDataVersionInfo, MetadataAnalysisRequest } from '../features/ad-data-tester/types/AdData'
import { optionalJson } from './helpers'
import { internalApiserverApi } from './internal-apiserver'
import { internalConnectApi } from './internal-connect'

const adDataConnectApi = internalConnectApi.injectEndpoints({
  endpoints: (builder) => ({
    // Filter searches can run for minutes; the staging gateway gives up after about three.
    searchAdDataAggregates: builder.query<AdDataAggregates, AdDataSearchRequest>({
      query: (body) => ({ url: 'i/aggregates/search', method: 'POST', body }),
      keepUnusedDataFor: 0,
    }),
    getAdDataAggregateDebug: builder.query<unknown, number>({
      query: (appId) => `i/aggregates/debug/${appId}`,
    }),
  }),
})

const adDataApiserverApi = internalApiserverApi.injectEndpoints({
  endpoints: (builder) => ({
    // `null` when the game has no version in the market.
    getAdDataVersionInfo: builder.query<AdDataVersionInfo | null, { appId: number; marketIso: string }>({
      query: ({ appId, marketIso }) => ({ url: `versions/${appId}`, params: { marketIso }, responseHandler: optionalJson }),
    }),
    requestMetadataAnalysis: builder.mutation<void, MetadataAnalysisRequest>({
      query: (request) => ({ url: 'i/metadata/request', method: 'POST', body: { appIds: [request] }, responseHandler: 'text' }),
    }),
    // Creates the game when it doesn't exist yet, then queues its metadata analysis.
    queueNewMetadataAnalysis: builder.mutation<void, MetadataAnalysisRequest>({
      async queryFn(request, _api, _extraOptions, baseQuery) {
        const created = await baseQuery({
          url: 'i/games/versioncheck/create',
          method: 'POST',
          body: { allowNonGames: false, appIds: [request.appId] },
          responseHandler: 'text',
        })
        if (created.error) return { error: created.error }
        const queued = await baseQuery({ url: 'i/metadata/request', method: 'POST', body: { appIds: [request] }, responseHandler: 'text' })
        if (queued.error) return { error: queued.error }
        return { data: undefined }
      },
    }),
  }),
})

export const { useLazySearchAdDataAggregatesQuery, useLazyGetAdDataAggregateDebugQuery } = adDataConnectApi
export const { useGetAdDataVersionInfoQuery, useRequestMetadataAnalysisMutation, useQueueNewMetadataAnalysisMutation } = adDataApiserverApi
